import { useContext, useEffect, useState } from "react";
import Spinner from "@kaizen-ui/spinner";
import {
  fetchMaintenance,
  postMaintenance,
  patcMaintenance,
  deleteMaintenance,
  patchMaintenance,
  fetchPermissionView 
} from "../../../api";
import { GetSelectedPermissions } from "../../../common/utils";
import { Layout } from "../../../layout";
import { useParams } from "react-router-dom";
import { Field, Formik } from "formik";
import Block from "@kaizen-ui/block";
import Button from "@kaizen-ui/button";
import Textbox from "@kaizen-ui/textbox";
import * as React from "react";
import "./styles.css";
import { BlockSection } from "@kaizen-ui/block";
import ButtonGroup from "@kaizen-ui/button";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import { string, object } from "yup";
import "./styles.css";
import { Banner, KaizenThemeContext } from "@kaizen-ui/complete";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PermissionTable from "../../../components/permissiontable";
import AccessibilityContext from "../../../components/auth/UserPermissionContext";
import WithAuth from "../../../components/auth/WithAuth";
import WithAdminUIAuth from "../../../components/auth/WithAdminUIAuth";
import { Checkbox } from "@kui-react/checkbox";
const Loading = () => (
  <Layout title="Loading...">
    <Spinner className="loading-spinner" size="small" />
  </Layout>
);
const initstate = {
  maintenanceid: 0,
  isNotice: false,
  isAnnouncement : false,
  fromDate : "",
  toDate : ""
};
const validationSchema = object().shape({
  isNotice: string().required("Is Notice is required."),
  isannouncment: string().required("Is Announcement is required."),
});


function MaintenanceDetail() {
  let { id } = useParams();
  const [data, setData] = useState();
  const [error, setError] = useState();
  const [errormsg, setErrorMsg] = useState("");
  const [initialValues] = useState(initstate);
  const [success, setSuccess] = useState("");
  const { colors } = useContext(KaizenThemeContext);

  const [expanded, setExpanded] = React.useState(false);

  // const [items, setItems] = useState(initialItems);
  const [items, setItems] = useState([]);
  // const [acptPermissions, setacptPermissions] = useState([]);
  // const [selectedPermissions, setselectedPermissions] = useState([]);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const disableDelete = () => {
    if (id > 0) {
      return false;
    }
    return true;
  };


  function errorHandler(error, setError, setErrorMsg) {
    setErrorMsg(error.status_message);
    setError(error);
    setTimeout(() => {
      setError(undefined);
    }, 5000);
  }

  function SuccessHandler(setSuccess, setData, data, navigate) {
    setTimeout(() => {
      setSuccess("");
      if (data !== undefined) {
        setData(data);
        navigate("/maintenance");
        //navigate("/role/" + data.roleid);
        //id = data.roleid.toString();
      } else {
        navigate("/maintenance");
      }
    }, 2000);
  }

  const deleteMaintenanceClick = () => {
    if (id !== undefined && data !== undefined) {
      const bconfirm = window.confirm("Do you want to delete the Maintenance?");
      if (bconfirm) {
        const payload = {
          ...data,
          isActive: false,
          fromDate: fromUtcPickerValue(data.fromDate),
          toDate: fromUtcPickerValue(data.toDate),
        };
  
        patchMaintenance(payload)
          .then(() => {
            setSuccess("Successfully deleted maintenance");
            SuccessHandler(setSuccess, undefined, undefined, navigate);
          })
          .catch((error) => {
            errorHandler(error, setError, setErrorMsg);
          });
      }
    }
  };
  

  useEffect(() => {
    if (id === "0") {
      setData({
        maintenanceid: 0,
        isNotice: false,
        isAnnouncement: false,
        fromDate : "",
        toDate : ""
      });

      fetchPermissionView(Number(id)).then((data) => {
        setItems(data);
      });
    } else {
;
        fetchMaintenance(Number(id)).then((data) => {
          const fromUtc = data.fromDate ? new Date(data.fromDate) : null;
          const toUtc = data.toDate ? new Date(data.toDate) : null;

          setData({
            ...data,
            fromDate: fromUtc,
            toDate: toUtc,
          });
        });


    }
  }, [id]);

  // shift real UTC date to fake "local" so DatePicker shows it as UTC
function toUtcPickerValue(date) {
  if (!date) return null;
  return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
}

// shift back to true UTC when saving
function fromUtcPickerValue(fakeDate) {
  if (!fakeDate) return null;
  return new Date(fakeDate.getTime() - fakeDate.getTimezoneOffset() * 60000);
}

  const navigate = useNavigate();
  if (!data) return <Loading />;

    return (
      <Formik
        initialValues={data !== null ? data : initialValues}
        initialTouched={{
          isNotice: true,
          maintenanceid: true,
          isAnnouncement: true,
          fromDate: true,
          toDate : true
        }}
        onReset={(values) => {
          values = data;
        }}
        onSubmit={(values, actions) => {
          actions.setSubmitting(true);
        
          const payload = {
            ...values,
            fromDate: fromUtcPickerValue(values.fromDate),
            toDate: fromUtcPickerValue(values.toDate),
          };
        
          if (id === "0") {
            postMaintenance(payload)
              .then((data) => {
                setSuccess("Successfully created maintenance");
                SuccessHandler(setSuccess, setData, data, navigate);
              })
              .catch((error) => {
                errorHandler(error, setError, setErrorMsg);
              })
              .finally(() => {
                actions.setSubmitting(false);
              });
          } else {
            patchMaintenance(payload)
              .then((data) => {
                setSuccess("Successfully updated maintenance");
                SuccessHandler(setSuccess, setData, data, navigate);
              })
              .catch((error) => {
                errorHandler(error, setError, setErrorMsg);
              })
              .finally(() => {
                actions.resetForm();
                actions.setSubmitting(false);
              });
          }
        }}
        //validationSchema={validationSchema}
        //validateOnMount
      >
        {(formikProps) => (
          <Layout
            title="Maintenance"
            headerChildren={
              <ButtonGroup>
                <Button
                  icon={{ name: "PlaybackCircleRewind", variant: "solid" }}
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  Go Back
                </Button>
              </ButtonGroup>
            }
          >
            {error && error !== undefined ? (
              // <Result status="error" title="Error" subTitle={JSON.stringify(errormsg)}  />
              <Banner
                className="bannertofront"
                rounded
                status="critical"
                title="Error"
              >
                {JSON.stringify(errormsg)}
              </Banner>
            ) : (
              ""
            )}
            {success !== "" ? (
              <Banner
                className="bannertofront"
                rounded
                status="success"
                title="Success"
              >
                {success}
              </Banner>
            ) : (
              //<Result status="success" title={success} />
              ""
            )}
            <Block
              inline
              className="form-example"
              loading={formikProps.isSubmitting}
            >
              <BlockSection size="full" className="hubtagfieldblocksection">
              <div className="checkbox-container" style={{gap:'34px'}}>
                <h4 className="hubtagfieldh4" style={{ color: colors.fontColor }}>
                  Maintenance Downtime
                </h4>
                <Checkbox
                  value={formikProps.values.isNotice}
                  checked={formikProps.values.isNotice}
                  //onChange={toggleIsNoticeCheckboxEvent()}
                  onChange={(e) => {
                    formikProps.setFieldValue("isNotice", e.target.checked);
                    formikProps.setFieldValue("isAnnouncement", false); // mutually exclusive
                  }}
                  id="isNotice"
                  name="isNotice"
                />
              </div>
              </BlockSection>

              <BlockSection
                            size="full"
                            className="hubtagfieldblocksection"
                          >
                            <div className="checkbox-container">
                            <h4
                              className="hubtagfieldh4"
                              style={{ color: colors.fontColor }}
                            >
                              Maintenance Announcement
                            </h4>

                            <Checkbox
                              value={formikProps.values.isAnnouncement}
                              checked={formikProps.values.isAnnouncement}
                              //onChange={toggleIsAnnouncementCheckboxEvent()}
                              onChange={(e) => {
                                formikProps.setFieldValue("isAnnouncement", e.target.checked);
                                formikProps.setFieldValue("isNotice", false); // mutually exclusive
                              }}
                              //disabled={disableEditField("isActive")}
                              id="isAnnouncement"
                              name="isAnnouncement"
                            />
                            </div>
              </BlockSection>

              <BlockSection  className="hubtagfieldblocksection">
                <div className="date-control" style={{gap:'26px'}}>
                <h4 className="hubtagfieldh4">Maintenance From Date <span style={{ color: "red" }}>*</span></h4>
                  <DatePicker
                    selected={(formikProps.values.fromDate)}
                    onChange={(date) => formikProps.setFieldValue("fromDate", (date))}
                    dateFormat="dd-MM-yyyy hh:mm a"
                    showTimeSelect
                    timeFormat="hh:mm aa"
                    className="custom-datepicker"
                  />
                </div>
              </BlockSection>

              <BlockSection  className="hubtagfieldblocksection">
                <div className="date-control" style={{gap:'41px'}}>
                  <h4 className="hubtagfieldh4">Maintenance To Date <span style={{ color: "red" }}>*</span></h4>
                  <DatePicker
                    selected={(formikProps.values.toDate)}
                    onChange={(date) => formikProps.setFieldValue("toDate", (date))}
                    dateFormat="dd-MM-yyyy hh:mm a"
                    showTimeSelect
                    timeFormat="hh:mm aa"
                    className="custom-datepicker"
                  />
                </div>
              </BlockSection>

              <BlockSection size="full">
                <Button
                  className="formsubmitbtn"
                  type="critical"
                  onClick={() => navigate("/maintenance")}
                >
                  Cancel
                </Button>

                <Button
                  className="formsubmitbtn"
                  //disabled={disableEdit()}
                  onClick={() => {
                    formikProps.isSubmitting = true;
                    formikProps.handleSubmit();
                  }}
                >
                  Submit
                </Button>
              </BlockSection>
              <BlockSection size="full">

                  <Button
                    className="formsubmitbtn"
                    type="critical"
                    disabled={disableDelete()}
                    onClick={(e) => deleteMaintenanceClick()}
                  >
                    Delete Maintenance
                  </Button>
                
              </BlockSection>
            </Block>
          </Layout>
        )}
      </Formik>
    );
  
}

export default WithAuth(WithAdminUIAuth(MaintenanceDetail));
